import AbstractConfigProvider from './AbstractConfigProvider';

export default class SeoConfigProvider extends AbstractConfigProvider {
    public prefix: string = 'seo';

    public getConfig() {
        return {
            ...this.add('add_trailing_slash_to_urls', process.env.MIX_SEO_ADD_TRAILING_SLASH_TO_URLS || 'false'),
        };
    }
}
